import { Invoice } from "./invoice";
import { Product } from "./product";
import { SystemField } from "./system-field";

export class InvoiceDetail extends SystemField {  
     invoices_id?:string;
     qty?:number;
     unit_price?:number;
     cost?:number;
     products_id?:string;
     service_date?:string;
     discount_amount?:number;
     discount_rate?:number; 

     //formula fields
     amount?:number;
     total_amount?:number;

     //relationship
     invoice?:Invoice;
     product?: Product;
     langs?:any;
}
export class InvoiceDetailTranslation extends SystemField{ 
     lang_code?:string;
     sale_desc?:string;
     invoice_details_id?:string;
}
